import {NgModule} from '@angular/core'
import {SelectComponent} from './select.component'
import {CommonModule} from '@angular/common'
import {ReactiveFormsModule} from '@angular/forms'
import {SpinnerComponent} from '../../spinner/spinner.component'
import {PipesModule} from '../../../shared/pipes/pipes.module'
import {I18nDirective} from '../../i18n/i18n.directive'

@NgModule({
  declarations: [SelectComponent],
  imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, PipesModule, I18nDirective],
  exports: [SelectComponent],
})
export class SelectModule {}
